import bank1 from './bank1.svg';
import bank2 from './bank2.svg';
import bank3 from './bank3.svg';
import bank4 from './bank4.svg';

export const banks = [bank1, bank2, bank3, bank4];
